<template>
  <div>
    <!-- dialog -->
    <el-dialog title="รายละเอียดผู้ดูแลระบบ" :visible.sync="show"  :before-close="handleClose">
      <!-- <h4>{{data_dialog}}</h4> -->
      <div class="box-img">
        <div class="show_img">
          <img
            :src="config().API_URL+data.profile_img"
          />
        </div>
      </div>
      <div class="layout_detail_modal">
        <div class="row">
          <label for="ชื่อ-นามสกุล">ชื่อ-นามสกุล : {{data.first_name+" "+data.last_name}}</label>
        </div>
        <div class="row new-space-user">
          <label for="อีเมล">อีเมล : {{data.email}}</label>
        </div>
        <div class="row new-space-user">
          <label for="เบอร์โทรศัพท์">เบอร์โทรศัพท์ : {{data.phone_number}}</label>
        </div>
        <div class="row new-space-user">
          <label for="ชื่อผู้ใช้งาน">ชื่อผู้ใช้งาน : {{data.username}}</label>
        </div>
        <div class="row new-space-user">
          <label for="หน่วยงาน">หน่วยงาน : {{data.departments}}</label>
        </div>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">Cancel</el-button>
                      <el-button type="primary" @click="dialogFormVisible = false">Confirm</el-button>
      </span>-->
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      labelPosition: "top",
      show: false
    };
  },
  created() {
    //do something after creating vue instance
  },
  watch: {
    dialog() {
      this.show = this.dialog;
    }
  },
  props: ["data", "dialog"],
  methods: {
    handleClose(done) {
      this.$emit("checkModal", false);
      done();
    }
  }
};
</script>
